<template>
<div class="wrapper">
  <div class="grid">
    <ul>
      <li>
        <figure>
          <v-lazy-image src-placeholder="https://johnnyvetterli.com/2020/skeleton.gif" src="https://johnnyvetterli.com/2020/hooksandhighs-min.png" alt="Screenshot of website merlinmattheeuws.ch" />
          <figcaption></figcaption>
        </figure>
        <h3>www.hooksandhighs.com</h3>
        <p class="tags">
          <span class="tag">HTML</span>
          <span class="tag">CSS</span>
          <span class="tag">JavaScript</span>
          <span class="tag">SEO</span>
          <span class="tag">Administration</span>
          <span class="tag">Email</span>
          <span class="tag">Support</span>
          <span class="tag">Frontend</span>
          <span class="tag">Squarespace</span>
        </p>
        <a href="https://hooksandhighs.com" target="_blank"><span class="arrow">></span> <span class="linkTitle">Visit Website</span></a>
      </li>
      <li>
        <figure>
          <v-lazy-image src-placeholder="https://johnnyvetterli.com/2020/skeleton.gif" src="https://johnnyvetterli.com/2020/merlin-min.jpg" alt="Screenshot of website merlinmattheeuws.ch" />
          <figcaption></figcaption>
        </figure>
        <h3>www.merlinmattheeuws.ch</h3>
        <p class="tags">
          <span class="tag">Design</span>
          <span class="tag">Prototype</span>
          <span class="tag">Deployment</span>
          <span class="tag">HTML</span>
          <span class="tag">JavaScript</span>
          <span class="tag">Vue JS</span>
          <span class="tag">PHP</span>
          <span class="tag">Cockpit CMS</span>
          <span class="tag">Responsive</span>
          <span class="tag">Frontend</span>
          <span class="tag">Backend</span>
        </p>
        <a href="https://merlinmattheeuws.ch" target="_blank"><span class="arrow">></span> <span class="linkTitle">Visit Website</span></a>
      </li>
      <li>
        <figure>
          <v-lazy-image src-placeholder="https://johnnyvetterli.com/2020/skeleton.gif" src="https://johnnyvetterli.com/2020/gitseine.jpg" alt="Logo of Gitseine clothing brand"/>
          <figcaption></figcaption>
        </figure>
        <h3>Gitseine Logo</h3>
        <p class="tags">
          <span class="tag">Logo Design</span>
        </p>
        <!-- <a href="#"><span class="arrow">></span> <span class="linkTitle">Visit Website</span></a> -->
      </li>
      <li>
        <figure>
          <v-lazy-image src-placeholder="https://johnnyvetterli.com/2020/skeleton.gif" src="https://johnnyvetterli.com/2020/secondnamej-min.jpg" alt="Screenshot of website secondnamej.com"/>
          <figcaption></figcaption>
        </figure>
        <h3>www.secondnamej.com</h3>
        <p class="tags">
          <span class="tag">Design</span>
          <span class="tag">HTML</span>
          <span class="tag">JavaScript</span>
          <span class="tag">PHP</span>
          <span class="tag">Bludit</span>
          <span class="tag">CMS</span>
          <span class="tag">Responsive</span>
          <span class="tag">Frontend</span>
          <span class="tag">Backend</span>
        </p>
        <a href="https://secondnamej.com" target="_blank"><span class="arrow">></span> <span class="linkTitle">Visit Website</span></a>
      </li>
      <li>
        <figure>
          <v-lazy-image src-placeholder="https://johnnyvetterli.com/2020/skeleton.gif" src="https://johnnyvetterli.com/enero.gif" alt="Animated gif showing enero website concept"/>
          <figcaption></figcaption>
        </figure>
        <h3>Enero Concept</h3>
        <p class="tags">
          <span class="tag">Design</span>
          <span class="tag">Adobe XD</span>
          <span class="tag">Prototype</span>
        </p>
        <!-- <a href="#"><span class="arrow">></span> <span class="linkTitle">Visit Website</span></a> -->
      </li>
    </ul>
  </div>
</div>
</template>
<script>

import VLazyImage from "v-lazy-image";

export default {
  name: 'Grid',
  components: {
    VLazyImage
  }
}
</script>
<style scoped lang="scss">

.grid {
  padding: 2rem;
  margin-bottom: 230px;
    ul {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
      grid-gap: 1.5rem;

      li {
        border-radius: .25rem;
        color: #e9e9e9;
        margin-bottom: 1rem;

        figure {
          max-height: 240px;
          min-height: 180px;
          overflow: hidden;
          border-top-left-radius: .25rem;
          border-top-right-radius: .25rem;
          position: relative;

          .v-lazy-image {
            opacity: 0;
            transition: opacity 2s;
          }
          .v-lazy-image-loaded {
            opacity: 1;
          }

          img {
            width: 100%;
            min-height: 180px;
            transition: 0.5s cubic-bezier(0,0,.3,1);
          }

          figcaption {
            position: absolute;
            bottom: 0;
            background-color: rgba(0,0,0,.98);
            width: 100%;
            transition: 0.5s cubic-bezier(0,0,.3,1);
          }
        }
        h3 {
          color: white;
          padding: .75rem 0 0;
          font-size: 1.25rem;
          // font-size: 1.6em;
        }
        p {
          font-size: 1rem;
          line-height: 1.5;
          padding: .75rem 0 .25rem 0;
          // color: rgb(110, 112, 114);

            span.tag {
                display: inline-block;
                padding: 0px 5px;
                background: rgb(30, 32, 34);
                margin: .15rem;
            }
        }
        a {
          // padding: .5rem 1rem;
          padding: .5rem 0;
          // margin: .5rem;
          text-decoration: none;
          // color: #dbdbdb;
          border-radius: .25rem;
          text-align: center;
          display: inline-block;
          transition: 0.5s cubic-bezier(0,0,.3,1);
          // background: rgb(30, 32, 34);
            span {
              transition: 0.5s cubic-bezier(0,0,.3,1);
            }
        }
        a:hover span.linkTitle {
            padding-left: 7px;
        }
      }
    }
}
</style>